import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import Api from "../Api/Api";
import * as yup from "yup";

function Login() {
  const [singupContral, setSingupContral] = useState(true);
  const [loginButtonLoader, setLoginButtonLoader] = useState(true);
  const [eyeIconManagersinup, setEyeIconManagersinup] = useState(false);
  const [eyeIconManagersSinupConfirm, setEyeIconManagersSinupConfirm] =
    useState(false);
  const centerDivRef = useRef(null);
  const [gameNoAuth, setGameNoAuth] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hasUParam = queryParams.has("u");
  const uValue = queryParams.get("u");

  const [loading, setLoading] = useState(false);
  console.log("location", singupContral);
  // login section
  console.log("hasParam", hasUParam, uValue);

  const validation = yup.object({
    userName: yup.string().required("User Name is required"),
    password: yup.string().required("Password is required"),
  });

  const formDataSubmit = async (values) => {
    setLoginButtonLoader(false);
    // console.log("submit", values);
    setLoading(true);
    // const valuesData=JSON.stringify(values)
    // const formData= new FormData()
    // formData.append('email',values.email)
    // formData.append('password',values.password)
    try {
      const response = await Api.post("/user/login/", values);
      // console.log("response---->login", response.data);
      localStorage.setItem("Quizetoken", response.data.result.token);
      localStorage.setItem("UserIdclient", response.data.result.user.userID);
      localStorage.setItem("UserIdMongo", response.data.result.user._id);
      localStorage.setItem("GameId", response.data.result.user.gameId);
      localStorage.setItem("userName", response.data.result.user.userName);
      localStorage.setItem("wallet", response.data.result.user.wallet);

      window.dispatchEvent(new Event("storage"));
      resetParentProperty();
      navigate("/", { state: { msg: response.data.message, replace: true } });
    } catch (error) {
      // console.log(error.response.data.message);
      toast(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
    }
    setLoginButtonLoader(true);
    formik.resetForm();
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
    },
    validationSchema: validation,
    onSubmit: (values) => formDataSubmit(values),
  });

  // Register page

  const initalValueReg = {
    name: "",
    // email: "",
    // phone: "",
    // password: "",
    // confirmPassword: "",
  };

  const validationReg = yup.object({
    name: yup.string().required("Weshareabundance Sponsor Name is required"),
    // .min(3, "Name must be at least 3 characters")
    // .max(50, "Name must not exceed 50 characters")
    // .matches(/^[A-Za-z\s]+$/, "Name must only contain alphabets and spaces"),
    // email: yup
    //   .string()
    //   .required("Email is required")
    //   .email("Email is invalid")
    //   .test(
    //     "is-valid-email",
    //     "Email must be a valid email address",
    //     (value) => {
    //       // Add your custom validation logic here
    //       return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    //     }
    //   ),
    // phone: yup
    //   .string()
    //   .required("Phone number is required")
    //   .matches(
    //     /^[0-9]{6,15}$/,
    //     "Phone number must be numeric and between 6 to 15 digits"
    //   ),
    // password: yup
    //   .string()
    //   .required("Password is required")
    //   .min(8, "Password must be at least 8 characters"),
    // confirmPassword: yup
    //   .string()
    //   .oneOf([yup.ref("password"), null], "Passwords must match")
    //   .required("Confirm Password is required"),
  });

  const RegisterSubmit = async (values) => {
    setGameNoAuth(true);
    // setLoginButtonLoader(false);
    // console.log("submit", values);
    // // const valuesData=JSON.stringify(values)
    // // const formData= new FormData()
    // // formData.append('email',values.email)
    // // formData.append('password',values.password)
    // try {
    //   const response = await axios.post("/user/signup", values);
    //   console.log("response---->Register", response.data);
    //   // localStorage.setItem("Quizetoken",response.data.result.token)
    //   toast(response.data.message, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    //   setSingupContral(true);
    // } catch (error) {
    //   console.log(error.response.data.message);
    //   toast(error.response.data.message, {
    //     position: "top-right",
    //     autoClose: 2000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     type: "error",
    //   });
    // }
    // setLoginButtonLoader(true);
  };

  const formikreg = useFormik({
    initialValues: initalValueReg,
    validationSchema: validationReg,
    onSubmit: (values) => RegisterSubmit(values),
  });

  // console.log("signup", singupContral);

  const signup = () => {
    setGameNoAuth(true);
    // alert(
    //   "Signup on We Share Abundance website and come back to our site to login and play games"
    // );
  };
  // useEffect(() => {
  //     if(location.state){
  //       toast(location.state, {
  //         position: "top-right",
  //         autoClose: 2000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //     });
  //     }
  //     window.history.replaceState({}, document.title)
  //   }, [location])

  useEffect(() => {
    if (hasUParam) {
      console.log("haaa", hasUParam, uValue)
      setSingupContral(false);
      // console.log("Signup Val")
      // formikreg.values.name = uValue;
      formikreg.setFieldValue("name", uValue);
    }
  }, [hasUParam]);

  // console.log("formikreg", formikreg.values.name);
  console.log("hasPAram", hasUParam);

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("!232", singupContral)
  }, [singupContral]);

  useEffect(() => {
    if (centerDivRef.current) {
      const parentDiv = centerDivRef.current.parentNode; // Access the parent div

      // Log or manipulate the parent div as needed
      if (parentDiv) {
        const grandParentDiv = parentDiv.parentNode;
        const grandGrandParentDiv = grandParentDiv.parentNode;
        const headerSection = parentDiv.querySelector(".header-section");
        const headerMenu = parentDiv.querySelector(".header-menu");
        const sidebar = grandGrandParentDiv.querySelector(
          ".sidebar.break-point-sm.has-bg-image"
        );

        if (headerSection) headerSection.style.display = "none";
        if (headerMenu) headerMenu.style.display = "none";
        if (sidebar) sidebar.style.display = "none";
      }
    }
  }, []);

  const resetParentProperty = () => {
    const parentDiv = centerDivRef.current.parentNode;
    const grandParentDiv = parentDiv.parentNode;
    const grandGrandParentDiv = grandParentDiv.parentNode;
    const headerSection = parentDiv.querySelector(".header-section");
    const headerMenu = parentDiv.querySelector(".header-menu");
    const sidebar = grandGrandParentDiv.querySelector(
      ".sidebar.break-point-sm.has-bg-image"
    );

    if (headerSection) headerSection.style.display = "";
    if (headerMenu) headerMenu.style.display = "";
    if (sidebar) sidebar.style.display = "";
  };

  useEffect(() => {
    // console.log("nav");
    const handlePopState = () => {
      // Logic to handle the back button
      // For example, you can reset forms or navigate to a specific route
      formik.resetForm(); // Reset login form
      formikreg.resetForm(); // Reset registration form
      resetParentProperty(); // Reset parent properties if needed
      // navigate("/", { replace: true }); // Navigate to home and replace history
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <>
      <ToastContainer />
      {singupContral ? (
        <div className="center" ref={centerDivRef}>
          <div className="video-form container">
            <div className="row align-items-center">
              <div className="col-lg-5 col-md-12">
                <div className="log-img">
                  <img src="/assets/images/login.png" />
                </div>
              </div>
              <div className="col-lg-7 col-md-12 ">
                <form onSubmit={formik.handleSubmit}>
                  <Link
                    to="/"
                    onClick={() => {
                      formik.resetForm(); // Reset login form
                      formikreg.resetForm(); // Reset registration form
                      resetParentProperty();
                    }}
                  >
                    <i
                      className="fa-solid fa-angle-left"
                      style={{ color: "black" }}
                    ></i>
                  </Link>
                  <div className="form-header">
                    <h2>Welcome Back</h2>
                    <p>Welcome back please enter your detail</p>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <label
                      for="email"
                      className="labelstyl"
                      style={{ marginBottom: "0px" }}
                    >
                      <b>User Name</b>
                    </label>
                    <input
                      type="text"
                      name="userName"
                      value={formik.values.userName}
                      onChange={formik.handleChange}
                      placeholder="Enter User Name"
                      style={{
                        cursor: "text",
                        color: "black",
                      }}
                    />
                    {formik.touched.userName && formik.errors.userName ? (
                      <div className="text-danger" style={{ float: "right" }}>
                        {formik.errors.userName}
                      </div>
                    ) : null}
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <label style={{ marginBottom: "0px" }}>
                      <b>Password</b>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={`${eyeIconManagersinup ? "text" : "password"}`}
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        placeholder="Enter Password"
                        style={{ cursor: "text", color: "black" }}
                      />
                      <i
                        className={`${
                          eyeIconManagersinup
                            ? "fa-regular fa-eye"
                            : "fa-regular fa-eye-slash"
                        }`}
                        style={{
                          position: "absolute",
                          right: "20px",
                          top: eyeIconManagersinup ? "47%" : "47%",
                          transform: "translateY(-39%)",
                          fontSize: "large",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          setEyeIconManagersinup(!eyeIconManagersinup)
                        }
                      ></i>
                    </div>
                    {formik.touched.password && formik.errors.password ? (
                      <div
                        className="text-danger"
                        style={{ float: "right", padding: "9px" }}
                      >
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>

                  {/* <Link to="/forgot" className="forgot">Forgot Password?</Link> */}
                  <button
                    type="submit"
                    style={{ marginTop: "18px" }}
                    disabled={loading ? true : false}
                  >
                    <a>{loginButtonLoader ? "Log In" : "Please wait"}</a>{" "}
                  </button>
                  <a
                    onClick={() => {
                      setSingupContral(!singupContral);
                      formik.resetForm(); // Reset login form
                      formikreg.resetForm(); // Reset registration form
                    }}
                    className="signup-like"
                  >
                    Don’t have an account? <span> Sign Up</span>
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="center">
          <div className="video-form container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <div className="log-img">
                  <img src="/assets/images/login.png" />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <form
                  onSubmit={formikreg.handleSubmit}
                  style={{ marginLeft: 0 }}
                >
                  <Link
                    to="/"
                    onClick={() => {
                      formik.resetForm(); // Reset login form
                      formikreg.resetForm(); // Reset registration form
                      resetParentProperty();
                    }}
                  >
                    <i
                      className="fa-solid fa-angle-left"
                      style={{ color: "black" }}
                    ></i>
                  </Link>
                  <div className="form-header">
                    <h2>Create Account</h2>
                    <p style={{ margin: "7px" }}>
                      Let’s Create Account Together
                    </p>
                    {/* <p>Signup on We Share Abundance website and come back to our site to login and play games</p> */}
                  </div>
                  <label for="email">
                    <b>Weshareabundance Sponsor's Name</b>
                  </label>
                  <input
                    type="Text"
                    name="name"
                    value={formikreg.values.name}
                    onChange={formikreg.handleChange}
                    placeholder="Please enter your Weshareabundance (WSA) sponsor's username "
                    style={{ color: "black", cursor: "text" }}
                  />
                  {formikreg.touched.name && formikreg.errors.name ? (
                    <div className="text-danger">{formikreg.errors.name}</div>
                  ) : null}

                  {/* <label for="email">
                    <b>Email</b>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formikreg.values.email}
                    onChange={formikreg.handleChange}
                    placeholder="Enter Email Id"
                  />
                  {formikreg.touched.email && formikreg.errors.email ? (
                    <div className="text-danger" style={{ float: "right" }}>
                      {formikreg.errors.email}
                    </div>
                  ) : null} */}

                  {/* <label for="phone">
                    <b>Phone No.</b>
                  </label>
                  <input
                    type="number"
                    name="phone"
                    value={formikreg.values.phone}
                    onChange={formikreg.handleChange}
                    placeholder="Enter Phone No."
                  />
                  {formikreg.touched.phone && formikreg.errors.phone ? (
                    <div className="text-danger" style={{ float: "right" }}>
                      {formikreg.touched.phone && formikreg.errors.phone}
                    </div>
                  ) : null} */}

                  {/* <label for="psw"><b>Password</b></label>
                        <div style={{ position: 'relative' }}>
                        <input type={`${eyeIconManagersinup ? 'text' : 'password'}`} name='password' value={formikreg.values.password} onChange={formikreg.handleChange} placeholder="Password" className="psw1" />
                        <i className={`${eyeIconManagersinup ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'}`} style={{ position: 'absolute', right: '20px', top: '44%', transform: 'translateY(-50%)', fontSize: 'large', cursor: 'pointer' }} onClick={()=>setEyeIconManagersinup(!eyeIconManagersinup)}></i>
                        </div>
                        {formikreg.touched.password && formikreg.errors.password ? <div className='text-danger' style={{float: 'right'}}>{formikreg.errors.password}</div> : null}
            
                        <label for="psw"><b> Confirm Password</b></label>
                        <div style={{ position: 'relative' }}>
                        <input type={`${eyeIconManagersSinupConfirm ? 'text' : 'password'}`}  name='confirmPassword' value={formikreg.values.confirmPassword} onChange={formikreg.handleChange} placeholder="Confirm Password"  />
                        <i className={`${eyeIconManagersSinupConfirm ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'}`}  style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', fontSize: 'large', cursor: 'pointer' }} onClick={()=>setEyeIconManagersSinupConfirm(!eyeIconManagersSinupConfirm)}></i>
                        </div> 
                        {formikreg.touched.confirmPassword && formikreg.errors.confirmPassword ? <div className='text-danger' style={{float: 'right'}}>{formikreg.errors.confirmPassword}</div> : null}
             */}
                  <button
                    type="submit"
                    className="mt-5"
                    // onClick={() => {
                    //   setGameNoAuth(true);
                    // }}
                  >
                    <a> {loginButtonLoader ? "Sign up" : "Please wait"}</a>
                  </button>
                  <a
                    onClick={() => {
                      setSingupContral(!singupContral);
                      formik.resetForm(); // Reset login form
                      formikreg.resetForm(); // Reset registration form
                    }}
                    className="signup-like"
                  >
                    Already have an account? <span> Log In</span>
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {gameNoAuth ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: gameNoAuth ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div
                className="modal-body"
                style={{ paddingTop: "8px", paddingBottom: "13px" }}
              >
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setGameNoAuth(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5
                      style={{
                        color: "#20205f",
                        textAlign: "center",
                        textTransform: "none",
                      }}
                    >
                      You will now be redirected to our parent site
                      membersnew.weshareaundance.com for registration.
                    </h5>
                    <h6 className="mt-3" style={{ textTransform: "none" }}>
                      Come back to our site Trivia Fun to login and enjoy
                      playing
                    </h6>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setGameNoAuth(false);
                            window.open(
                              `https://membersnew.weshareabundance.com/register?u=${formikreg.values.name}`,
                              "_blank"
                            );
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginTop: "2px" }}
                        >
                          {" "}
                          Okay, Sign up
                          {/* {loading ? "Please wait" : "Login"} */}
                        </a>
                        <a
                          onClick={() => setGameNoAuth(false)}
                          className="box-style btn-box d-center hoverstyle"
                        >
                          {" "}
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Login;
